import type { Ref } from 'vue';

import {
    type AuctionItemEntity,
    type AuctionListingItemEntity,
    type DealerSaleItemEntity,
    type DealerSaleListingItemEntity,
    type DirectSaleItemEntity,
    type DirectSaleListingItemEntity,
    type OfflineSaleItemEntity,
    type OfflineSaleListingItemEntity,
    SellingMethod,
} from '~/apiClient';
import type { SaleItemEntity, SaleListingItemEntity } from '~/types/sale.type';
import type { SaleStatus } from '~/types/saleStatus';

export default function useSaleStatus(sale: Ref<SaleItemEntity | SaleListingItemEntity>): SaleStatus {
    const { sellingMethod } = sale.value;

    switch (sellingMethod) {
        case SellingMethod.Auction:
            return useAuctionStatus(sale as Ref<AuctionItemEntity | AuctionListingItemEntity>);
        case SellingMethod.DirectSale:
            return useDirectSaleStatus(sale as Ref<DirectSaleItemEntity | DirectSaleListingItemEntity>);
        case SellingMethod.OfflineSale:
            return useOfflineSaleStatus(sale as Ref<OfflineSaleItemEntity | OfflineSaleListingItemEntity>);
        case SellingMethod.DealerSale:
            return useDealerSaleStatus(sale as Ref<DealerSaleItemEntity | DealerSaleListingItemEntity>);

        default:
            throw new Error(`Unhandled selling method: ${sellingMethod satisfies never}`);
    }
}
